import React, {useEffect, useState} from 'react';
import './freeTieSection.scss';
import FormInput from "../../../../components/inputs/FormInput";
import 'react-phone-number-input/style.css'
import PhoneInput, {
	formatPhoneNumber,
	formatPhoneNumberIntl,
	isPossiblePhoneNumber,
	isValidPhoneNumber
} from 'react-phone-number-input';
import Popover from '@mui/material/Popover';
import FreeTieItemCard from "./components/FreeTieItemCard";
import {colorsOptions} from "../../../../components/utils/collectionData";
import FreeTieModal from "./components/FreeTieModal";
import { Rating } from 'react-simple-star-rating'
import {useTranslation} from "react-i18next";
import { CreateCustomerReferredFriend, CreateCustomerReview } from "../../../../components/api/freeTieCustomerApi";

const FreeTieSection = () => {
	const { t } = useTranslation();
	const [name, setName] = useState('');
	const [surname, setSurname] = useState('');
	const [email, setEmail] = useState('');
	const [address, setAddress] = useState('');
	const [phoneNr, setPhoneNr] = useState();
	const [postNr, setPostNr] = useState('');
	const [postSted, setPostSted] = useState('');
	const [selectedColor, setSelectedColor] = useState<any>(null);
	const [openModal, setOpenModal] = useState(false);
	const [modalContent, setModalContent] = useState<'thank' |'review' | 'thankFeedback' | 'reviewForm' | 'thankReviewForm' | null >(null);
	const [rating, setRating] = useState(5);
	const [review, setReview] = useState('');

	const [nameReview, setNameReview] = useState('');
	const [surnameReview, setSurnameReview] = useState('');
	const [emailReview, setEmailReview] = useState('');
	const [addressReview, setAddressReview] = useState('');
	const [phoneNrReview, setPhoneNrReview] = useState();
	const [postNrReview, setPostNrReview] = useState('');
	const [postStedReview, setPostStedReview] = useState('');
	const [selectedColorReview, setSelectedColorReview] = useState<any>(null);

	const [anchorEl, setAnchorEl] = useState(null);
	const [anchorElReview, setAnchorElReview] = useState(null);
	const [loading, setLoading] = useState(true);
	
	const [width, setWidth]   = useState(window.innerWidth);

	const updateDimensions = () => {
		setWidth(window.innerWidth);
	}

	useEffect(() => {
		window.addEventListener("resize", updateDimensions);
		return () => window.removeEventListener("resize", updateDimensions);
	}, []);

	const handleClick = (event: any) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClickReview = (event: any) => {
		setAnchorElReview(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const handleCloseReview = () => {
		setAnchorElReview(null);
	};

	const open = Boolean(anchorEl);
	const openReview = Boolean(anchorElReview);

	const id = open ? 'simple-popover' : undefined;
	const idReview = openReview ? 'simple-popover-review' : undefined;

	const handleSelect = (item: any) => {
		setSelectedColor(item);
		console.log("item: ", item);
		setAnchorEl(null);
	}

	const handleSelectReview = (item: any) => {
		setSelectedColorReview(item);
		console.log("item: ", item);
		setAnchorElReview(null);
	}

	const clearFreeSampleForm = () => {
		setName('');
		setSurname('');
		// setEmail('');
		setAddress('');
		setPhoneNr(undefined);
		setPostNr('');
		setPostSted('');
		setSelectedColor(null);
	};

	const clearReviewForm = () => {
		setNameReview('');
		setSurnameReview('');
		setEmailReview('');
		setAddressReview('');
		setPhoneNrReview(undefined);
		setPostNrReview('');
		setPostStedReview('');
		setSelectedColorReview(null);
	};

	const handleGetFreeSample = (e: any) => {
		e.preventDefault();
		setOpenModal(true);
		setModalContent('thank');
	}

	const handleSendReviewForm = async (e: any) => {
		e.preventDefault();
		if (selectedColorReview && selectedColorReview.title) {
			let formData = new FormData();
			const date = new Date();
			date.toUTCString();
			
			try {
				if (nameReview && surnameReview && addressReview && phoneNrReview && postNrReview && postStedReview && emailReview) {
					setLoading(true);
					const result = await CreateCustomerReferredFriend({
						customerEmail: email.toLowerCase(),
						name: nameReview,
						surname: surnameReview,
						email: emailReview.toLowerCase(),
						address: addressReview,
						mobile: `+${phoneNrReview}`,
						postalCode: postNrReview,
						postalArea: postStedReview,
						color: selectedColorReview.title,
						size: selectedColorReview.image,
					})
					
					console.log("CreateCustomerReferredFriend result: ", result);
					if (result) {
						setEmail('');
						clearReviewForm();
						setOpenModal(true);
						setModalContent('thankReviewForm');
						
						setTimeout(() => {
							handleCloseModal();
						}, 5000);
					}
				}
			} catch (e) {
				console.error(e);
			} finally {
				setLoading(false);
			}

			/* formData.append('FromWhom', email);
			formData.append('Date', `${date}`);
			formData.append('Tie', selectedColorReview.image);
			formData.append('Name', nameReview);
			formData.append('Surname', surnameReview);
			formData.append('Email', emailReview.toLowerCase());
			formData.append('Address', addressReview);
			formData.append('PhoneNr', `${phoneNrReview}`);
			formData.append('PostNr', postNrReview);
			formData.append('PostSted', postStedReview);
			formData.append('Color', selectedColorReview.title);

			fetch(process.env.REACT_APP_GOOGLE_SHEET as string, {
				method: 'POST',
				body: formData,
			}).then(res => {
				if (!res.ok) {
					throw new Error('Network response was not ok');
				}
				return res.json();
			})
				.then(data => {
					console.log(data);
					// clearFreeSampleForm();
					setEmail('');
					clearReviewForm();
					setOpenModal(true);
					setModalContent('thankReviewForm');
				})
				.catch(err => {
					console.error('There was a problem with the fetch operation:', err);
					alert('Submission failed. Please try again.');
				}); */
		}
	}

	const handleSendReview = async (e: any) => {
		e.preventDefault();
		if (selectedColor && selectedColor.title) {
			let formData = new FormData();
			const date = new Date();
			date.toUTCString();
			
			try {
				if (name && surname && address && postNr && postSted && email && phoneNr) {
					setLoading(true);
					const result = await CreateCustomerReview({
						name: name,
						surname: surname,
						email: email.toLowerCase(),
						address: address,
						mobile: `+${phoneNr}`,
						postalCode: postNr,
						postalArea: postSted,
						color: selectedColor.title,
						rate: `${rating}`,
						size: selectedColor.image,
						review: review,
					})
					console.log("CreateCustomer result: ", result);
					if (result) {
						setReview('');
						clearFreeSampleForm();
						setOpenModal(true);
						setModalContent(rating < 5 ? 'thankFeedback' : 'reviewForm');
						if (rating < 5) {
							setTimeout(() => {
								handleCloseModal();
							}, 5000);
						}
					}
				}
			} catch (e) {
				console.error(e);
			} finally {
				setLoading(false);
			}

			/* formData.append('FromWhom', `Oneself`);
			formData.append('Date', `${date}`);
			formData.append('Tie', selectedColor.image);
			formData.append('Name', name);
			formData.append('Surname', surname);
			formData.append('Email', email.toLowerCase());
			formData.append('Address', address);
			formData.append('PhoneNr', `${phoneNr}`);
			formData.append('PostNr', postNr);
			formData.append('PostSted', postSted);
			formData.append('Color', selectedColor.title);
			formData.append('Rating', `${rating}`);
			formData.append('Review', review);

			
			fetch(process.env.REACT_APP_GOOGLE_SHEET as string, {
				method: 'POST',
				body: formData,
			}).then(res => {
				if (!res.ok) {
					throw new Error('Network response was not ok');
				}
				return res.json();
			})
				.then(data => {
					console.log(data);
					setReview('');
					clearFreeSampleForm();
					setOpenModal(true);
					setModalContent(rating < 5 ? 'thankFeedback' : 'reviewForm')
				})
				.catch(err => {
					console.error('There was a problem with the fetch operation:', err);
					alert('Submission failed. Please try again.');
				}); */
		}
	}

	const handleRating = (rate: number) => {
		setRating(rate)
	}

	const handleCloseModal = () => {
		setOpenModal(false);
		setModalContent(null);
		clearFreeSampleForm();
		clearReviewForm();
	}

	const isValidFreeSampleForm = () => {
		return !!(selectedColor?.title &&
			name &&
			surname &&
			email.includes('@') &&
			address &&
			phoneNr &&
			postNr &&
			postSted);
	};

	const isValidReviewForm = () => {
		return !!(selectedColorReview?.title &&
			nameReview &&
			surnameReview &&
			emailReview.includes('@') &&
			addressReview &&
			phoneNrReview &&
			postNrReview &&
			postStedReview);
	};

	return (
		<div className="freeTie">
			<div className="freeTie__content">
				<div className="freeTie__content_header">
					<h3>{t('freeTie.getYourFree')}{/*<br/>{t('freeTie.kosibandHairTie')}*/}</h3>
					{/* <span>{t('freeTie.discover')}</span> */}
					<span dangerouslySetInnerHTML={{ __html: t('freeTie.discover') }} />
				</div>
				{/*<div className="freeTie__content">*/}
					<div className="freeTie__content_data">
						<div className="freeTie__content_data_row">
							<FormInput
								label={t('freeTie.form.name')}
								value={name}
								onChange={setName}
							/>
							<FormInput
								label={t('freeTie.form.surname')}
								value={surname}
								onChange={setSurname}
							/>
						</div>
						<div className="freeTie__content_data_row">
							<FormInput
								label={t('freeTie.form.email')}
								value={email}
								onChange={setEmail}
							/>
							<FormInput
								label={t('freeTie.form.address')}
								value={address}
								onChange={setAddress}
							/>
						</div>
						<div className="freeTie__content_data_row third">
							<div className="freeTie__content_data_row_phone">
								<div className="formInput__label">
									<span>{t('freeTie.form.phoneNr')}</span>
								</div>
								<div className="formInput__input">
									<PhoneInput
										defaultCountry="NO"
										placeholder={t('freeTie.form.enterPhoneNr')}
										value={phoneNr}
										onChange={(newValue: any) => setPhoneNr(newValue)}
										error={phoneNr ? (isValidPhoneNumber(phoneNr) ? undefined : 'Invalid phone number') : 'Phone number required'}
									/>
								</div>
							</div>
							<FormInput
								label={t('freeTie.form.postNr')}
								value={postNr}
								onChange={setPostNr}
							/>
							<FormInput
								label={t('freeTie.form.postSted')}
								value={postSted}
								onChange={setPostSted}
							/>
						</div>
						<div className="freeTie__content_data_row color">
							{/*<FormInput
								label={'Choose a color'}
								value={selectedColor}
								onChange={setSelectedColor}
							/>*/}
							<div className="formInput__label">
								<span>{t('freeTie.form.chooseColor')}</span>
							</div>

							<button
								className={`freeTie__content_color_btn ${open ? 'open' : ''}`}
								aria-describedby={id}
								onClick={handleClick}
								// onMouseEnter={handleClick}
								// onMouseLeave={handleClose}
							>
								<span>{
									selectedColor &&
									selectedColor.title
										?
										`${selectedColor.title} ${selectedColor.secondTitle ? '&&' : ''} ${selectedColor.secondTitle ? selectedColor.secondTitle : ''}`
										:
										t('freeTie.form.color')
								}</span>
								<svg xmlns="http://www.w3.org/2000/svg" width="16" height="10" viewBox="0 0 16 10" fill="none">
									<path d="M15 1.5L8 8.5L1 1.5" stroke="#F37021" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
								</svg>
							</button>
							<Popover
								id={id}
								open={open}
								anchorEl={anchorEl}
								onClose={handleClose}
								anchorOrigin={{
									vertical: 'bottom',
									horizontal: 'left',
								}}
							>
								<div className="freeTie__modal">
									<div className="freeTie__modal_content">
										{
											colorsOptions && colorsOptions.length > 0 ?
												colorsOptions.slice(0, 29).map((item: any, index: number) => (
													<FreeTieItemCard
														key={`${item.title} - ${index}`}
														title={item.title}
														secondTitle={item.secondTitle}
														description={item.description}
														image={item.image}
														onPress={() => handleSelect(item)}
													/>
												)) : null
										}
									</div>
								</div>
							</Popover>
						</div>
					</div>
				{/*</div>*/}
				<div className="freeTie__content_btn">
					<button
						className={`mainButton ${isValidFreeSampleForm() ? '' : 'inactive'}`}
						disabled={!isValidFreeSampleForm()}
						onClick={handleGetFreeSample}
					>
						<span>{t('buttons.getFreeSample')}</span>
					</button>
				</div>
			</div>

			{/*
		'thank': false,
		'review': false,
		'thankFeedback': false,
		'reviewForm': false,
		'thankReviewForm': false,
			*/}
			<FreeTieModal
				open={openModal}
				handleClose={handleCloseModal}
			>
				<div className="freeTieModal">
					<div className="freeTieModal__content">
					{
						modalContent === 'thank' ? (
							<div className="freeTieModal__content_thank">
								<div className="freeTieModal__content_thank_close">
									<button onClick={handleCloseModal}>
										<svg xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33" fill="none">
											<path d="M1.83722 1.85991L31.557 31.537M31.5357 1.83856L1.85857 31.5584" stroke="#F37021" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
										</svg>
									</button>
								</div>
								<div className="freeTieModal__content_thank_data">
									<div className="freeTieModal__content_thank_data_info">
										<h3>{t('freeTie.form.thankYou')}</h3>
										<span>{t('freeTie.form.thankDescription')}</span>
									</div>

									<button
										className={`mainButton`}
										onClick={() => setModalContent('review')}
									>
										<span>{t('buttons.ok')}</span>
									</button>
								</div>
							</div>
						) : modalContent === 'review' ? (
							<div className="freeTieModal__content_review review">
								<div className="freeTieModal__content_review_close">
									<button onClick={handleCloseModal}>
										<svg xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33" fill="none">
											<path d="M1.83722 1.85991L31.557 31.537M31.5357 1.83856L1.85857 31.5584" stroke="#F37021" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
										</svg>
									</button>
								</div>
								<div className="freeTieModal__content_review_data">
									<div className="freeTieModal__content_review_data_info">
										<h3>{t('freeTie.form.reviewTitle')}</h3>
									</div>
									<div className="freeTieModal__content_review_data_rating">
										<Rating
											onClick={handleRating}
											transition={true}
											SVGstrokeColor={"#F37021"}
											fillColor={"#F37021"}
											emptyColor={"#fff"}
											size={width < 768 ? 36 : 72}
											initialValue={5}
										/>
									</div>

									<div className="freeTieModal__content_review_data_review">
										<div className="formInput__label">
											<span>{t('freeTie.form.yourReview')}</span>
										</div>
										<textarea
											className="formInput__input"
											value={review}
											onChange={(event: any) => setReview(event.currentTarget.value)}
										/>
									</div>

									<button
										className={`mainButton ${review ? '' : 'inactive'}`}
										disabled={!review}
										onClick={handleSendReview}
									>
										<span>{t('buttons.send')}</span>
									</button>
								</div>
							</div>
						) : modalContent === 'thankFeedback' ? (
							<div className="freeTieModal__content_thank feedback">
								<div className="freeTieModal__content_thank_close">
									<button onClick={handleCloseModal}>
										<svg xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33" fill="none">
											<path d="M1.83722 1.85991L31.557 31.537M31.5357 1.83856L1.85857 31.5584" stroke="#F37021" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
										</svg>
									</button>
								</div>
								<div className="freeTieModal__content_thank_data">
									<div className="freeTieModal__content_thank_data_info">
										<h3>{t('freeTie.form.thankYouFeedback')}</h3>
										<span>{t('freeTie.form.thankDescriptionFeedback')}</span>
									</div>
								</div>
							</div>
						) : modalContent === 'reviewForm' ? (
							<div className="freeTieModal__content_review form">
								<div className="freeTieModal__content_review_close">
									<button onClick={handleCloseModal}>
										<svg xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33" fill="none">
											<path d="M1.83722 1.85991L31.557 31.537M31.5357 1.83856L1.85857 31.5584" stroke="#F37021" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
										</svg>
									</button>
								</div>
								<div className="freeTieModal__content_review_data">
									<div className="freeTieModal__content_review_data_info">
										<h3>{t('freeTie.form.thankYou')}<br/>{t('freeTie.form.forYouRating')}</h3>
										<span>{t('freeTie.form.thankYouRatingDescription')}</span>
									</div>
									<div className="freeTieModal__content_review_data_review">
										<div className="freeTie__content_data_row">
											<FormInput
												label={t('freeTie.form.name')}
												value={nameReview}
												onChange={setNameReview}
											/>
											<FormInput
												label={t('freeTie.form.surname')}
												value={surnameReview}
												onChange={setSurnameReview}
											/>
										</div>
										<div className="freeTie__content_data_row">
											<FormInput
												label={t('freeTie.form.email')}
												value={emailReview}
												onChange={setEmailReview}
											/>
											<FormInput
												label={t('freeTie.form.address')}
												value={addressReview}
												onChange={setAddressReview}
											/>
										</div>
										<div className="freeTie__content_data_row third">
											<div className="freeTie__content_data_row_phone">
												<div className="formInput__label">
													<span>{t('freeTie.form.phoneNr')}</span>
												</div>
												<div className="formInput__input">
													<PhoneInput
														defaultCountry="NO"
														placeholder={t('freeTie.form.enterPhoneNr')}
														value={phoneNrReview}
														onChange={(newValue: any) => setPhoneNrReview(newValue)}
														error={phoneNr ? (isValidPhoneNumber(phoneNr) ? undefined : 'Invalid phone number') : 'Phone number required'}
													/>
												</div>
											</div>
											<FormInput
												label={t('freeTie.form.postNr')}
												value={postNrReview}
												onChange={setPostNrReview}
											/>
											<FormInput
												label={t('freeTie.form.postSted')}
												value={postStedReview}
												onChange={setPostStedReview}
											/>
										</div>
										<div className="freeTie__content_data_row color">
											{/*<FormInput
								label={'Choose a color'}
								value={selectedColor}
								onChange={setSelectedColor}
							/>*/}
											<div className="formInput__label">
												<span>{t('freeTie.form.chooseColor')}</span>
											</div>

											<button
												className={`freeTie__content_color_btn ${openReview ? 'open' : ''}`}
												aria-describedby={idReview}
												onClick={handleClickReview}
												// onMouseEnter={handleClick}
												// onMouseLeave={handleClose}
											>
												<span>{
													selectedColorReview &&
													selectedColorReview.title
														?
														`${selectedColorReview.title} ${selectedColorReview.secondTitle ? '&&' : ''} ${selectedColorReview.secondTitle ? selectedColorReview.secondTitle : ''}`
														:
														t('freeTie.form.color')
												}</span>
												<svg xmlns="http://www.w3.org/2000/svg" width="16" height="10" viewBox="0 0 16 10" fill="none">
													<path d="M15 1.5L8 8.5L1 1.5" stroke="#F37021" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
												</svg>
											</button>
											<Popover
												id={idReview}
												open={openReview}
												anchorEl={anchorElReview}
												onClose={handleCloseReview}
												anchorOrigin={{
													vertical: 'bottom',
													horizontal: 'left',
												}}
											>
												<div className="freeTie__modal">
													<div className="freeTie__modal_content">
														{
															colorsOptions && colorsOptions.length > 0 ?
																colorsOptions.map((item: any, index: number) => (
																	<FreeTieItemCard
																		key={`${item.title} - ${index}`}
																		title={item.title}
																		secondTitle={item.secondTitle}
																		description={item.description}
																		image={item.image}
																		onPress={() => handleSelectReview(item)}
																	/>
																)) : null
														}
													</div>
												</div>
											</Popover>
										</div>
									</div>
									<button
										className={`mainButton ${isValidReviewForm() ? '' : 'inactive'}`}
										disabled={!isValidReviewForm()}
										onClick={handleSendReviewForm}
									>
										<span>{t('buttons.send')}</span>
									</button>
								</div>
							</div>
						) : modalContent === 'thankReviewForm' ? (
							<div className="freeTieModal__content_thank feedback">
								<div className="freeTieModal__content_thank_close">
									<button onClick={handleCloseModal}>
										<svg xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33" fill="none">
											<path d="M1.83722 1.85991L31.557 31.537M31.5357 1.83856L1.85857 31.5584" stroke="#F37021" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
										</svg>
									</button>
								</div>
								<div className="freeTieModal__content_thank_data">
									<div className="freeTieModal__content_thank_data_info">
										<h3>{t('freeTie.form.thankYou')}</h3>
										<span>{t('freeTie.form.thankDescriptionReview')}</span>
									</div>
								</div>
							</div>
						) : null
					}
				</div>
				</div>
			</FreeTieModal>
		</div>
	);
};

export default FreeTieSection;